import { FileFieldV2 } from '../form/fields/file/input';
import { ICustomerDocuments, IDocumentItem } from '@components/molecules/drive-upload-modal/drive-upload-modal';

export const DocumentItem = ({
  title,
  description,
  onFileChange,
  loading = false,
  name,
}: IDocumentItem): JSX.Element => {
  return (
    <div className=" bg-white p-0">
      <FileFieldV2<ICustomerDocuments>
        label=""
        allowedFileTypes={['application/pdf', 'image/jpeg', 'image/png', 'image/jpg']}
        onChangeFiles={onFileChange}
        loading={loading}
        field={name as keyof ICustomerDocuments}
        id={name}
        description={title}
        maximumFileSizeInMB={6 * 1024 * 1024}
        multipleFiles
      />
      {description && <p className="text-xs text-gray-500 mt-2">{description}</p>}
    </div>
  );
};
